import { LicenciaService } from './../services/licencia.service';
import { ClasesService } from './../services/clases.service';
import { CursosService } from './../services/cursos.service';
import { ColegiosService } from './../services/colegios.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { UserService } from '../services/user.service';
import { AngularFireFunctions } from '@angular/fire/functions';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.css'],
})
export class RegistroComponent implements OnInit {
  nombres: string = null;
  apellidos: string = null;
  email: string = null;
  password: string = null;
  direccion: string = null;
  licencia: string = null;
  pin: string = null;
  fechana: string = null;
  colegio: string = null;
  cursos = [];
  localidad: string = null;
  asignaturas = [];
  response: string = null;
  pais: string = '';
  genero: string = '';
  telefono: string = '';

  colegiosdb: any = '';
  cursosdb = [];
  clasesdb = [];
  colegiodata: any;
  cursodata: any;
  asignaturadata: any;
  regcolegio: any;
  regcurso: any;
  regasignatura = [];
  licenciadb: any;
  licenciaId: string = null;
  confirmacion = false;
  error = false;
  enviado = true;
  mayuscula = false;
  minuscula = false;
  numero = false;
  caracter = false;
  caractount = false;

  infoPassword: boolean = false;
  licenciaCorrecta = false;
  idColegio = '';
  nombreColegio = '';

  registerEmail = false;
  usuario: any = '';
  existeUsuario: boolean = false;
  en: boolean;
  es: boolean;
  ar: boolean;
  click: boolean;
  idioma: any;
  lang: string;
  instruccionespdf =
    'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';

  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private cursosService: CursosService,
    private clasesService: ClasesService,
    private licenciaService: LicenciaService,
    private functions: AngularFireFunctions,
    private colegiosService: ColegiosService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.asignaturas = new Array();

    if (localStorage.getItem('idioma')) {
      this.lang = localStorage.getItem('idioma');
      this.translate.setDefaultLang(this.lang);
      this.translate.use(this.lang);
      switch (this.lang) {
        case 'es':
          this.es = true;
          this.instruccionespdf =
            'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
          break;
        case 'en':
          this.en = true;
          this.instruccionespdf =
            'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
          break;
        case 'ar':
          this.ar = true;
          this.instruccionespdf =
            'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
          break;
        default:
          this.instruccionespdf =
            'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
          break;
      }
    } else {
      this.es = true;
      this.translate.setDefaultLang('es');
      this.translate.use('es');
      localStorage.setItem('idioma', 'es');
    }

    // this.getmaindata();
  }

  // getmaindata() {
  //   this.getcolegios();
  // }

  // getcolegios() {
  //   this.colegiosService.getColegiosNow().subscribe((colegios) => {
  //     this.colegiosdb = colegios;
  //   });
  // }

  selectcolegio(event) {
    let obs1 = this.cursosService
      .getCursosByColegioidNow(event)
      .subscribe((cursos) => {
        this.cursosdb = new Array();
        cursos.forEach((curso) => {
          this.cursosdb.push(curso);
        });
        obs1.unsubscribe();
        // this.cursosdb = cursos[0];
        // this.selectcurso(cursos[0].payload.doc.id);

        // this.clasesService.getClaseByColegioNow(event).subscribe((clases) => {
        //   this.clasesdb = [];
        //   clases.forEach((seclase) => {
        //     if (
        //       !this.clasesdb.some(
        //         (el) => el.id === seclase.id
        //       )
        //     ) {
        //       this.clasesdb.push(seclase);
        //     }
        //   });
        // });
      });
  }

  selectcurso(event) {
    this.clasesdb = [];
    this.asignaturas = [];
    let obs2 = this.clasesService
      .getClaseByCursoidNow(event)
      .subscribe((clases) => {
        console.log(clases);
        this.clasesdb = [];
        clases.forEach((seclase) => {
          if (!this.clasesdb.some((el) => el.id === seclase.id)) {
            this.clasesdb.push(seclase);
          }
        });
        obs2.unsubscribe();
      });
  }

  existeUser() {
    this.existeUsuario = false;
  }

  setResponse(translationKey: string) {
    this.translate.get(translationKey).subscribe((data) => {
      this.response = data;
    });
  }

  register() {
    this.usuario = (this.usuario || '').replace(/\s+/g, '');
    if (this.usuario != '') {
      this.existeUser();
    }
    setTimeout(() => {
      if (this.existeUsuario) {
        this.setResponse('registro.responenombre');
        return;
      }

      if (this.nombres === null || this.nombres === '') {
        this.setResponse('registro.responsenombrevacio');
        return;
      }

      if (this.apellidos === null || this.apellidos === '') {
        this.setResponse('registro.responseapellidos');
        return;
      }

      if (this.fechana === null || this.fechana === '') {
        this.setResponse('registro.responsenacimiento');
        return;
      }

      if (
        typeof this.email !== 'string' ||
        this.email.trim() === '' ||
        !this.validateEmail(this.email.trim())
      ) {
        this.setResponse('registro.responseemail');
        return;
      }
      this.email = this.email.trim().toLowerCase();

      if (this.telefono === null || this.telefono === '') {
        this.setResponse('registro.responsetelefono');
        return;
      }

      // if (this.direccion === null || this.direccion === '') {
      //   this.translate.get('registro.responsedireccion').subscribe((data) => {
      //     this.response = data;
      //     return;
      //   });
      // }
      // if (this.pais === null || this.pais === '') {
      //   this.translate.get('registro.responsepais').subscribe((data) => {
      //     this.response = data;
      //     return;
      //   });
      // }
      if (this.genero === null || this.genero === '') {
        this.setResponse('registro.responsegenero');
        return;
      }

      if (this.password === null || this.password === '') {
        this.setResponse('registro.responsecontraseÃ±a');
        return;
      }

      if (this.licencia === null || this.licencia === '') {
        this.setResponse('registro.responselicencia');
        return;
      }

      // tslint:disable-next-line: max-line-length
      if (
        this.pin === null ||
        this.pin === '' ||
        !this.validateNumbers(this.pin) ||
        this.pin.toString().length > 4 ||
        this.pin.toString().length < 4
      ) {
        this.setResponse('registro.responsepin');
        return;
      }

      if (this.colegio === null || this.colegio === '') {
        this.setResponse('registro.responsecolegio');
        return;
      }

      if (this.cursos === undefined || this.cursos.length <= 0) {
        this.setResponse('registro.responsecurso');
        return;
      }

      if (this.asignaturas === undefined || this.asignaturas.length <= 0) {
        this.setResponse('registro.responseasignatura');
        return;
      }

      if (
        this.mayuscula !== true &&
        this.minuscula !== true &&
        this.numero !== true &&
        this.caracter !== true &&
        this.caractount !== true
      ) {
        this.setResponse('registro.responsecontraseÃ±asegura');
        return;
      }
      this.translate.get('registro.responseregistrando').subscribe((data) => {
        this.response = data;
        this.getcolegiodata();
      });
    }, 2500);
  }

  getcolegiodata() {
    let obs4 = this.colegiosService
      .getColegioByIdNow(this.colegio)
      .subscribe((colegio) => {
        this.colegiodata = colegio;
        this.regcolegio = [this.colegio];
        this.updatelicencia();
        // obs4.unsubscribe();
      });
  }

  updatelicencia() {
    let obs5 = this.licenciaService
      .searchLicenciaNow(this.licencia)
      .subscribe((licen1) => {
        if (licen1.empty) {
          this.error = true;
          this.enviado = false;
          this.confirmacion = false;

          this.translate
            .get('registro.responsenumerolicencia')
            .subscribe((data) => {
              this.response = data;
              obs5.unsubscribe();
              return;
            });
        }
        licen1.forEach((licen) => {
          console.log(licen);
          this.licenciadb = licen.data();
          console.log(this.colegiodata.id);
          if (
            this.licenciadb.used == false &&
            this.licenciadb.school.toLowerCase() ==
              this.colegiodata.id.toLowerCase()
          ) {
            console.log('licenciaAntes', this.licenciadb);
            this.licenciaId = licen.id;
            this.licenciaCorrecta = false;
            this.getcursodata();
          } else {
            this.error = true;
            this.enviado = false;
            this.confirmacion = false;

            this.translate
              .get('registro.responselicenciaincorrecta')
              .subscribe((data) => {
                this.response = data;
              });
          }
        });
        obs5.unsubscribe();
      });
  }

  getcursodata() {
    this.regcurso = [this.cursos];
    this.getclasedata();
  }

  getclasedata() {
    this.regasignatura = [...this.asignaturas];
    this.registeruser();
  }

  registeruser() {
    this.authenticationService
      .registerWithEmail(this.email, this.password)
      .then((data) => {
        if (this.registerEmail != false) {
          return;
        }

        this.registerEmail = true;
        if (!data) {
          this.error = true;
          this.enviado = false;
          this.confirmacion = false;
          this.registerEmail = false;

          this.translate
            .get('registro.responsenoregistrar')
            .subscribe((translation) => {
              this.response = translation;
            });
          return;
        }

        Promise.resolve()
          .then(() => {
            const user = {
              name: this.nombres.toLowerCase(),
              last_name: this.apellidos.toLowerCase(),
              email: this.email.toLowerCase(),
              // direccion: this.direccion,
              license: this.licencia,
              date_of_birth: new Date(this.fechana + ' 00:00'),
              schools: this.regcolegio,
              courses: (this.regcurso || []).map(
                (course) => course.uid || course.id || course
              ),
              // localidad: this.localidad,
              classes: this.regasignatura,
              uid: data.user.uid,
              // pais: this.pais,
              gender: this.genero,
              phone_number: this.telefono,
              avatar: '',
              code: '',
              role: 'student',
              username: this.usuario.toLowerCase(),
            };

            return this.userService.createdUser(user);
          })
          .then(() => {
            return this.updateclase(data.user.uid);
          })
          .then(() => {
            return this.licenciaId
              ? this.licenciaService.updateLicencia(this.licenciaId, {
                  ...this.licenciadb,
                  used: true,
                })
              : Promise.resolve();
          })
          .then(() => {
            // this.authenticationService.sendEmailverification();
            this.sendpexipdata();
          })
          .catch((error) => {
            console.error('Registration user creation failed', error);
            this.error = true;
            this.enviado = false;
            this.confirmacion = false;
            this.registerEmail = false;

            this.translate.get('registro.responsenocrear').subscribe((data) => {
              const backendError = error?.error?.error || error?.message;
              this.response = backendError ? `${data}: ${backendError}` : data;
            });
          });
      })
      .catch((error) => {
        console.error('Registration auth failed', error);
        this.error = true;
        this.enviado = false;
        this.confirmacion = false;
        this.registerEmail = false;

        this.translate
          .get('registro.responsenoregistrar')
          .subscribe((translation) => {
            const authError = error?.message || error?.code;
            this.response = authError ? `${translation}: ${authError}` : translation;
          });
      });
  }

  updateclase(newuseruid) {
    return Promise.all(
      this.asignaturas.map((asignatura) =>
        this.clasesService.addUserToClass(asignatura, newuseruid)
      )
    );
  }

  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validateNumbers(numbers) {
    const re = /^[0-9]+$/;
    return re.test(numbers);
  }

  testPassword(pwString) {
    if (pwString) {
      this.infoPassword = true;
    }
    if (/[A-Z]+/.test(pwString)) {
      this.mayuscula = true;
    } else {
      this.mayuscula = false;
    }

    if (/[a-z]+/.test(pwString)) {
      this.minuscula = true;
    } else {
      this.minuscula = false;
    }

    if (/[0-9]+/.test(pwString)) {
      this.numero = true;
    } else {
      this.numero = false;
    }

    if (/[\W]+/.test(pwString)) {
      this.caracter = true;
    } else {
      this.caracter = false;
    }

    if (pwString.length > 6) {
      this.caractount = true;
    } else {
      this.caractount = false;
    }
  }

  countnumers(event) {
    if (event.toString().length >= 4) {
      this.pin = event.toString().slice(0, -1);
    }
  }

  returntoform() {
    this.confirmacion = false;
    this.error = false;
    this.enviado = true;
  }

  sendpexipdata() {
    let nombre = this.nombres + ' ' + this.apellidos;
    nombre = nombre.replace(/[^a-zA-Z ]/g, '');
    let rand = Math.floor(Math.random() * (1000 - 0)) + 0;

    const bodydata = {
      name: this.usuario.toLowerCase(),
      description:
        this.nombres.normalize('NFD').replace(/[\u0300-\u036f]/g, '') +
        ' ' +
        this.apellidos.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
      primary_owner_email_address: this.email,
      automatic_participants: [],
      pin: this.pin,
      service_type: 'conference',
      call_type: 'video',
      max_callrate_in: '2048',
      max_callrate_out: '2048',
      allow_guests: true,
      participant_limit: 10,
      enable_overlay_text: true,
      tag: 'estudiante ' + this.nombreColegio,
      ivr_theme: '/api/admin/configuration/v1/ivr_theme/59/',
      aliases: [
        { alias: this.usuario.toLowerCase(), description: 'Nombre de Usuario' },
        {
          alias:
            this.nombres.normalize('NFD').replace(/[\u0300-\u036f]/g, '') +
            this.apellidos.normalize('NFD').replace(/[\u0300-\u036f]/g, '') +
            rand,
          description: 'NOMBRE APELLIDO NUMERO RANDOM',
        },
        {
          alias: 'user_' + this.licencia + '@thecampus.education',
          description: 'URI',
        },
      ],
    };

    const callable = this.functions.httpsCallable('addRoom');
    const obs = callable({ saladata: bodydata });

    obs.subscribe(async (res) => {
      this.enviado = false;
      this.confirmacion = true;
      this.error = false;
    });
  }

  comprobarDatosLincencia(codigo) {
    this.response = '';
    if (codigo) {
      this.clasesdb = [];
      this.asignaturas = [];
      let obs8 = this.licenciaService
        .searchLicenciaNow(codigo)
        .subscribe((licen1) => {
          if (licen1.empty) {
            this.colegiosdb = null;
            this.cursosdb = null;
            this.licenciaCorrecta = false;
            this.error = true;

            this.translate
              .get('registro.responselicencianovalida')
              .subscribe((data) => {
                this.response = data;
                obs8.unsubscribe();
                return;
              });
          }
          licen1.forEach((licen: any) => {
            console.log('licendata', licen.data());
            var licenciaDatos = licen.data();
            if (licenciaDatos.used == false) {
              this.colegiosService
                .getColegioByIdNow(licenciaDatos.school)
                .subscribe((cole) => {
                  if (!cole?.exists || !cole.data()) {
                    this.licenciaCorrecta = false;
                    this.error = true;

                    this.translate
                      .get('registro.responselicenciaincorrecta')
                      .subscribe((data) => {
                        this.response = data;
                      });
                    return;
                  }

                  console.log('cole', cole.data());
                  this.licenciaCorrecta = true;
                  this.colegio = cole.id;
                  this.idColegio = cole.id;
                  this.nombreColegio = cole.data()['name'];
                  this.colegiosdb = cole;
                  this.selectcolegio(licenciaDatos['school']);
                });
            } else {
              this.licenciaCorrecta = false;
              this.error = true;

              this.translate
                .get('registro.responselicenciaincorrecta')
                .subscribe((data) => {
                  this.response = data;
                });
            }
          });
          obs8.unsubscribe();
        });
    } else {
      this.error = true;
      this.translate
        .get('registro.responsenumerolicencia')
        .subscribe((data) => {
          this.response = data;
        });
    }
  }

  getClassId(event, uid) {
    if (event.target.checked) {
      //console.log(uid + " checked")
      this.asignaturas.push(uid);
    } else {
      //console.log(uid + " UNchecked");
      this.asignaturas = this.asignaturas.filter((m) => m != uid);
    }
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('idioma', lang);
  }

  espanol() {
    this.translate.use('es');
    this.es = true;
    this.en = false;
    this.ar = false;
    localStorage.setItem('idioma', 'es');
    this.instruccionespdf =
      'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
    this.activeLanguage();
  }

  ingles() {
    this.translate.use('en');
    this.en = true;
    this.es = false;
    this.ar = false;
    localStorage.setItem('idioma', 'en');
    this.instruccionespdf =
      'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
    this.activeLanguage();
  }

  arabe() {
    this.translate.use('ar');
    this.en = false;
    this.es = false;
    this.ar = true;
    localStorage.setItem('idioma', 'ar');
    this.instruccionespdf =
      'https://firebasestorage.googleapis.com/v0/b/the-campus-56b06.appspot.com/o/Instructions%20-%20Student%20Registration.pdf?alt=media&token=2cd1a393-cb51-4850-aa0c-2c18b6718d05';
    this.activeLanguage();
  }

  changeColor() {
    this.click = !this.click;
  }

  activeLanguage() {
    this.idioma ? (this.idioma = false) : (this.idioma = true);
  }

  // cargarColegioByLicencia(codigo) {
  //   this.licenciaService.searchLicencia(codigo).subscribe((licen) => {
  //     if (licen) {
  //       var licenciaDatos = licen[0].payload.doc.data();
  //       this.colegiosService
  //         .getColegioById(licenciaDatos['colegio'])
  //         .subscribe((cole) => {
  //           var arrayCole = new Array();
  //           arrayCole.push(cole);
  //           this.colegiosdb = arrayCole;
  //           arrayCole.pop();
  //           this.selectcolegio(licenciaDatos['colegio']);
  //         });
  //     } else {
  //       this.colegiosdb = null;
  //       this.cursosdb = null;
  //     }
  //   });
  // }
  //https://www.recordingandstreaming.com/play?id=%2FHFxnclobwqdu3fk4YgrSR9aA3Y72LbxLyzS6EQAxfp5qTU0tQYuYiWpqbMzT2nQSmCeghuvCTeIpxIPkdlG%2BhJG3mpd4yayqCWOX7Q5
}

